import { baseApi } from "./base.api";

export const subCategoriesApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    fetchSubCategories: build.query({
      query: (params) => ({ url: "/sub/categories/fetch", method: "GET", params }),
      providesTags: ["SubCategory"],
    }),
    fetchSubCategoriesAll: build.query({
      query: () => ({ url: "/sub/categories/fetch/all", method: "GET" }),
      providesTags: ["SubCategory"],
    }),
    fetchTrashedSubCategories: build.query({
      query: (params) => ({ url: "/sub/categories/fetch/trashed", method: "GET", params }),
      providesTags: ["SubCategory"],
    }),
    fetchSubCategoryById: build.query({
      query: (id) => ({ url: `/sub/categories/fetch/${id}`, method: "GET" }),
      providesTags: ["SubCategory"],
    }),
    createSubCategory: build.mutation({
      query: (body) => ({ url: "/sub/categories/create", method: "POST", body }),
      invalidatesTags: ["SubCategory"],
    }),
    updateSubCategory: build.mutation({
      query: ({ id, body }) => ({ url: `/sub/categories/update/${id}`, method: "PUT", body }),
      invalidatesTags: ["SubCategory"],
    }),
    changeSubCategoryStatus: build.mutation({
      query: (id) => ({ url: `/sub/categories/status/${id}`, method: "PUT" }),
      invalidatesTags: ["SubCategory"],
    }),
    restoreSubCategory: build.mutation({
      query: (id) => ({ url: `/sub/categories/restore/${id}`, method: "PUT" }),
      invalidatesTags: ["SubCategory"],
    }),
    bulkRestoreSubCategories: build.mutation({
      query: (body) => ({ url: "/sub/categories/bulk-restore", method: "POST", body }),
      invalidatesTags: ["SubCategory"],
    }),
    deleteSubCategory: build.mutation({
      query: (id) => ({ url: `/sub/categories/delete/${id}`, method: "DELETE" }),
      invalidatesTags: ["SubCategory"],
    }),
    bulkDeleteSubCategories: build.mutation({
      query: (body) => ({ url: "/sub/categories/bulk-delete", method: "POST", body }),
      invalidatesTags: ["SubCategory"],
    }),
    destroySubCategory: build.mutation({
      query: (id) => ({ url: `/sub/categories/destroy/${id}`, method: "DELETE" }),
      invalidatesTags: ["SubCategory"],
    }),
    bulkDestroySubCategories: build.mutation({
      query: (body) => ({ url: "/sub/categories/bulk-destroy", method: "POST", body }),
      invalidatesTags: ["SubCategory"],
    }),
  }),
});

export const {
  useFetchSubCategoriesQuery,
  useFetchSubCategoriesAllQuery,
  useFetchTrashedSubCategoriesQuery,
  useFetchSubCategoryByIdQuery,
  useCreateSubCategoryMutation,
  useUpdateSubCategoryMutation,
  useChangeSubCategoryStatusMutation,
  useRestoreSubCategoryMutation,
  useBulkRestoreSubCategoriesMutation,
  useDeleteSubCategoryMutation,
  useBulkDeleteSubCategoriesMutation,
  useDestroySubCategoryMutation,
  useBulkDestroySubCategoriesMutation,
} = subCategoriesApi;
